import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { HomeOverview } from '@/types/home'

/* ============================================================
 * 首页聚合（对齐后端 §十一 + 前端对接指南 §十四）
 *
 *   GET /app/home/overview
 *
 * 接口为 `@Anonymous`（无需登录），但 axios 走通用 `http` 实例：
 * 客户端请求拦截器在已登录时仍会附带 Bearer，不影响匿名访问。
 *
 * 返回值已剥两层包装（AxiosResponse → ApiResponse envelope → data），
 * 调用方拿到的是 `HomeOverview` 本身。
 * ============================================================ */

export function getHomeOverview(): Promise<HomeOverview> {
  return http
    .get<ApiResponse<HomeOverview>>('/app/home/overview')
    .then((r) => r.data.data)
}
